import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './reports.component';
import { AuthGuard, CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { PageTitle } from '../store-front/misc/page-title/page-title.component';
import { TabOptionsComponent } from '../../../components/tab-options/tab-options.component';
import { PricingStatusComponent } from './components/pricing-status/pricing-status.component';
import { reportsOccContentConfig } from './_core/reports.occ';
import { CreditSummaryComponent } from './components/credit-summary/credit-summary.component';
import { RouterModule } from '@angular/router';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { PurchaseSummaryComponent } from './components/purchase-summary/purchase-summary.component';
import { PaymentHistoryComponent } from './components/payment-history/payment-history.component';
import { AlertComponent } from '../../../components/alert/alert.component';
import { LocalLoaderComponent } from '../../../components/loader/local-loader/local-loader.component';

@NgModule({
  declarations: [ReportsComponent],
  imports: [
    CommonModule,
    PageTitle,
    I18nModule,
    TabOptionsComponent,
    PricingStatusComponent,
    PurchaseSummaryComponent,
    CreditSummaryComponent,
    PaymentHistoryComponent,
    AlertComponent,
    LocalLoaderComponent,
    RouterModule.forChild([
      {
        path: 'my-account/reports',
        component: PageLayoutComponent,
        data: { pageLabel: 'my-account/reports' },
        canActivate: [CmsPageGuard, AuthGuard],
      },
    ]),
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ReportsPageComponent: {
          component: ReportsComponent,
        },
      },
    }),
    provideConfig(reportsOccContentConfig),
    provideConfig({
      routing: {
        routes: {
          reportsPage: { paths: ['my-account/reports'] },
        },
      },
    }),
  ],
})
export class ReportsModule {}
